import { projectsData } from '../../data/projectsData.js'
import {
  ProjectLinkButton,
  SectionSubTitle,
  SectionTitle,
  BtnsDiv,
  Icon
} from '../../globalStyles.js'
import {
  MyWorkContainer,
  ProjectRow,
  Img,
  ProjectColumn,
  ProjectName,
  ProjectDesc,
  TagsDiv,
  Tag,
  ProjectsAndBlogsContainer
} from './MyWorkSection.elements'
import githubBtnIcon from '../../assets/button-icons/githubBtnIcon.svg'
import liveBtnIcon from '../../assets/button-icons/liveBtnIcon.svg'
import Blogs from './components/Blogs.jsx'

const MyWorkSection = () => {
  return (
    <MyWorkContainer id="mywork-section">
      <SectionTitle>
        <h3>MY WORK</h3>
      </SectionTitle>
      <Projects />
      <Blogs />
    </MyWorkContainer>
  )
}

function Projects() {
  return (
    <ProjectsAndBlogsContainer>
      <SectionSubTitle>
        <h5>Projects</h5>
      </SectionSubTitle>

      {projectsData?.map((project, index) => (
        <ProjectRow key={index}>
          <ProjectColumn firstColumn>
            <Img src={project?.image} alt={project.alt} />
          </ProjectColumn>
          <ProjectColumn>
            <ProjectName>{project?.name}</ProjectName>

            <ProjectDesc>{project?.desc}</ProjectDesc>

            {/* tags */}
            <TagsDiv>
              {project?.stack?.map((s, index) => (
                <Tag key={index}>{s}</Tag>
              ))}
            </TagsDiv>

            {/* btns */}
            <BtnsDiv>
              <ProjectLinkButton onClick={() => window.open(project?.liveURL)}>
                <Icon src={liveBtnIcon} alt="liveIcon" />
                VIEW LIVE
              </ProjectLinkButton>

              <ProjectLinkButton
                onClick={() => window.open(project?.githubURL)}
                style={{
                  marginLeft: '2rem'
                }}
              >
                <Icon src={githubBtnIcon} alt="liveIcon" />
                GITHUB
              </ProjectLinkButton>
            </BtnsDiv>
          </ProjectColumn>
        </ProjectRow>
      ))}
    </ProjectsAndBlogsContainer>
  )
}
export default MyWorkSection
